import { PayloadAction } from '@reduxjs/toolkit';
import { getContext, takeLatest } from 'redux-saga/effects';
import { sagaTaskDescriptor } from 'data';
import { PrereleaseFeature } from 'hooks/use-feature';
import { setFeatureFlagAction } from '../actions';

export const getFeatureFlagContext = function* () {
  return yield getContext('featureFlag');
};

function* setFeatureFlagContext({
  payload,
}: PayloadAction<{
  key: PrereleaseFeature;
  value: boolean;
}>) {
  const featureFlag = yield getFeatureFlagContext();

  sagaTaskDescriptor.setContext({
    featureFlag: {
      ...(featureFlag ?? {}),
      ...{
        [payload.key]: payload.value,
      },
    },
  });
}

export const watchFeatureFlagSaga = function* (): Generator {
  yield takeLatest(setFeatureFlagAction.type, setFeatureFlagContext);
};
